export const dateToHuman = (date) => {
  let d = new Date(date)
  return ("0" + d.getDate()).slice(-2) + "/" + ("0" + Number(d.getMonth() + 1)).slice(-2) + "/" + d.getFullYear()
}
